export const negColor:string = '#ff0000';
export const posColor:string = '#0ea600';
